import { render, staticRenderFns } from "./RiskComment.vue?vue&type=template&id=9b6da578&scoped=true"
import script from "./RiskComment.vue?vue&type=script&lang=js"
export * from "./RiskComment.vue?vue&type=script&lang=js"
import style0 from "./RiskComment.vue?vue&type=style&index=0&id=9b6da578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6da578",
  null
  
)

export default component.exports